import { Grid } from '@material-ui/core'
import styled from 'styled-components'

function MarkTableInstantResult({ correctNo, wrongNo }) {
    return (
        <MarkTable>
            <Grid container spacing={3}>
                <Grid
                    item
                    xs={7}
                    style={{
                        borderRight: '1px solid #363862'
                    }}
                >
                    <Grid container spacing={2} direction="column">
                        <Grid
                            item
                            style={{
                                borderBottom: '1px solid #363862'
                            }}
                        >
                            <p
                                style={{
                                    color: 'transparent'
                                }}
                            >
                                .....
                            </p>
                        </Grid>
                        <Grid
                            item
                            style={{
                                borderBottom: '1px solid #363862'
                            }}
                        >
                            Correct Answers
                        </Grid>
                        <Grid item>Wrong Answers</Grid>
                    </Grid>
                </Grid>
                <Grid
                    item
                    xs={2}
                    style={{
                        borderRight: '1px solid #363862'
                    }}
                >
                    <Grid container spacing={2} direction="column">
                        <Grid
                            item
                            style={{
                                borderBottom: '1px solid #363862'
                            }}
                        >
                            <p>No.s</p>
                        </Grid>
                        <Grid
                            item
                            style={{
                                borderBottom: '1px solid #363862'
                            }}
                        >
                            <p>{correctNo}</p>
                        </Grid>
                        <Grid item>
                            <p>{wrongNo}</p>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={3}>
                    <Grid container spacing={2} direction="column">
                        <Grid
                            item
                            style={{
                                borderBottom: '1px solid #363862'
                            }}
                        >
                            <p>Marks</p>
                        </Grid>
                        <Grid
                            item
                            style={{
                                borderBottom: '1px solid #363862'
                            }}
                        >
                            <p>{4 * correctNo}</p>
                        </Grid>
                        <Grid item>
                            <p>{-1 * wrongNo}</p>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </MarkTable>
    )
}

const MarkTable = styled.div`
    margin-top: 20px;

    p {
        text-align: center;
    }
`

export default MarkTableInstantResult
